import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AuthService = /** @class */ (function () {
    function AuthService(http) {
        this.http = http;
        this.currentSessionSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentSession')));
        this.currentSession = this.currentSessionSubject.asObservable();
    }
    AuthService.prototype.generateDynamoPortalToken = function () {
        return this.http.get(environment.server.api.auth + "/api/token/dynamo/getportaldata").pipe(map(function (response) { return response.data; }));
    };
    AuthService.prototype.auth = function (hash, token) {
        var _this = this;
        if (hash) {
            return this.http.post(environment.server.api.auth + "/api/token/legacy/decode/" + hash, null)
                .pipe(map(function (data) {
                if (data && data.jwt) {
                    var sessionData = {
                        jwt: data.jwt,
                        userId: data.legacy.userId,
                        username: data.legacy.username
                    };
                    _this.persistData(sessionData);
                    return true;
                }
                else {
                    _this.deletePersistedData();
                    return false;
                }
            }, function (error) {
                _this.deletePersistedData();
                return false;
            }));
        }
        else {
            return this.http.get(environment.server.api.auth + "/api/token/ValidateToken?token=" + token)
                .pipe(map(function (data) {
                if (data) {
                    var sessionData = {
                        jwt: token,
                        userId: data.userId,
                        username: data.username
                    };
                    localStorage.setItem('userInfo', JSON.stringify(data.userInfo));
                    _this.persistData(sessionData);
                    return true;
                }
                else {
                    _this.deletePersistedData();
                    return false;
                }
            }, function (error) {
                _this.deletePersistedData();
                return false;
            }));
        }
    };
    Object.defineProperty(AuthService.prototype, "currentSessionValue", {
        get: function () {
            return this.currentSessionSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.persistData = function (sessionData) {
        localStorage.setItem('currentSession', JSON.stringify(sessionData));
        this.currentSessionSubject.next(sessionData);
    };
    AuthService.prototype.deletePersistedData = function () {
        localStorage.removeItem('currentSession');
        localStorage.removeItem('tk');
        this.currentSessionSubject.next(null);
    };
    AuthService.prototype.generateSingleSignatureCreditAccess = function (cuit) {
        return this.http.get(environment.server.api.auth + "/api/SolaFirma?cuit=" + cuit);
    };
    AuthService.prototype.generateRetirementInsuranceAccess = function (cuit) {
        return this.http.get(environment.server.api.auth + "/api/Retiro?cuit=" + cuit);
    };
    AuthService.prototype.getToken = function () {
        return localStorage.getItem('tk');
    };
    AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.HttpClient)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
